import { Box, Flex, HStack, useColorModeValue } from "@chakra-ui/react"

import ColorModeSwitcher from "./ColorModeSwitcher"
import UserMenu from "./UserMenu"
import Notifications from "./Notifications"
import Reports from "./Reports"
import { bindActionCreators } from "redux"
import { navBarCreator } from "state/index"
import { useDispatch } from "react-redux"
import { useSelector } from "react-redux"
import { State } from "state/reducers"
import { House, List } from "@phosphor-icons/react"
import { Link } from "react-router-dom"
import Report from "./Report"

const Header = () => {
    const navBar = useSelector(({ navBar }: State) => navBar)
    const dispatch = useDispatch()
    const { switchNavbar } = bindActionCreators(navBarCreator, dispatch)

    const backgroundColor = useColorModeValue('green.600', 'health.primary');
    const { email } = useSelector(({ auth }: State) => auth);

    const canSeeReport = ['dev@healthid.com', 'admin@healthid.com'].includes(email);

    return (
        <Box
            position="fixed"
            right={0}
            top={0}
            zIndex="98">
            <Box
                w="100vw"
                height="60px"
                backgroundColor={backgroundColor}
            >
                <Flex w="full" h="full" justifyContent="space-between" alignItems="center">
                    <HStack spacing={4} pl={navBar ? 92 : 268} transition="padding ease 0.25s">
                        <Box cursor="pointer" onClick={() => switchNavbar(!navBar)}>
                            <List size={22} color="white" weight="bold" />
                        </Box>
                        <Link to="/">
                            <Box>
                                <House size={22} color="white" weight="duotone" />
                            </Box>
                        </Link>
                    </HStack>
                    <Flex
                        flexDirection="row-reverse"
                        justifyContent="flex-start"
                        alignItems="center"
                        w="100%"
                        h="100%"
                        px="32px"
                    >
                        <HStack spacing={6}>
                            {
                                canSeeReport && <Report />
                            }
                            <ColorModeSwitcher />
                            {/* <Notifications /> */}
                            <Reports />
                            {/* <UserMenu /> */}
                        </HStack>
                    </Flex>
                </Flex>
            </Box>
        </Box>
    )
}

export default Header